'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const version = "1.1.0-beta.24";

exports.version = version;
